import {Navigate, Outlet} from "react-router-dom";

export default function ProtectedRoute({session}) {
    return (
        session?.loggedIn ? <Outlet/> : <Navigate to="/login" replace/>
    );
};
